var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "municipalInfoDetail", "data-role": "page" } },
    [
      _c(
        "div",
        {
          staticClass: "municipalInfoDetail-content",
          attrs: { "data-position": "fixed" }
        },
        [
          !_vm.closeOffline && _vm.isOffline
            ? _c("div", { staticClass: "v3offline" }, [
                _c("i", { staticClass: "icon-exclamation-mark-circle" }),
                _vm._v(" "),
                _c("p", [_vm._v("未連接至網路")]),
                _vm._v(" "),
                _c("div", { on: { click: _vm.closeOfflineHandle } }, [
                  _c("i", { staticClass: "icon-close" })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.detailData.content
            ? _c("div", { staticClass: "detailWrap" }, [
                _c(
                  "div",
                  { staticClass: "detail-h" },
                  [
                    _vm.detailData.type == "municipal"
                      ? [
                          _c("span", { staticClass: "cgy-tag" }, [
                            _vm._v(_vm._s(_vm.detailData.content.MessageType))
                          ])
                        ]
                      : _vm.detailData.type == "village"
                        ? [
                            _vm.isGetProfileInfoSuccess
                              ? [
                                  _vm._l(
                                    _vm.detailData.content.VillageName,
                                    function(villageVal, villageIdx) {
                                      return villageIdx < 3
                                        ? _c(
                                            "span",
                                            {
                                              key: villageIdx,
                                              staticClass: "cgy-tag"
                                            },
                                            [_vm._v(_vm._s(villageVal))]
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.detailData.content.VillageName.length > 3
                                    ? _c("span", { staticClass: "cgy-tag" }, [
                                        _vm._v(
                                          "＋" +
                                            _vm._s(
                                              _vm.detailData.content.VillageName
                                                .length - 3
                                            )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ]
                        : _vm._e(),
                    _vm._v(" "),
                    _c("h3", { class: { LargSize: _vm.fz_larg } }, [
                      _vm._v(_vm._s(_vm.detailData.content.MessageTitle))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "article_date",
                        class: { LargSize: _vm.fz_larg }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.dateFormat(
                              _vm.detailData.content.MessageDate,
                              "YYYY/MM/DD"
                            )
                          )
                        )
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "detail-c" }, [
                  _c(
                    "div",
                    {
                      staticClass: "txtContent",
                      class: { LargSize: _vm.fz_larg }
                    },
                    [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.contentTransform(
                              _vm.detailData.content.MessageContent
                            )
                          )
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.detailData.content.Files &&
                _vm.detailData.content.Files.length > 0
                  ? _c("div", { staticClass: "detail-a" }, [
                      _c("div", { staticClass: "attachTitle" }, [
                        _vm._v("檢視附加檔案")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "attachFileWrap",
                          class: { LargSize: _vm.fz_larg }
                        },
                        _vm._l(_vm.detailData.content.Files, function(
                          files,
                          fileIdx
                        ) {
                          return _c(
                            "div",
                            {
                              key: fileIdx,
                              staticClass: "attachFile",
                              on: {
                                click: function($event) {
                                  _vm.OpenFile(files.FileLink, files.FileName)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "icon-clip" }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(files.FileName))])
                            ]
                          )
                        })
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.Authority
        ? _c(
            "div",
            {
              staticClass: "qk-functionBar active",
              attrs: { id: "v3functionBar" }
            },
            [
              _c("div", { class: ["qk-functionBar-wrap-col4"] }, [
                _c(
                  "div",
                  {
                    staticClass: "fontsize-option",
                    class: { active: _vm.fz_larg },
                    on: { click: _vm.ChanegSize }
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "share-option", on: { click: _vm.Share } },
                  [_vm._m(1)]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.v3Toast.show,
              expression: "v3Toast.show"
            }
          ],
          staticClass: "v3Toast"
        },
        [_vm._v(_vm._s(_vm.v3Toast.text))]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "icon-font-size" }),
      _vm._v("大小")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "icon-export" }), _vm._v("分享")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10ec8418", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ec8418","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/municipal/municipalInfoDetail.vue
// module id = null
// module chunks = 